import type BaseEnumType from "@/app/services/baseEnumType";
import type { Maybe } from "@/components/utils/typeHelpers";

export class EnumNumberFormat implements BaseEnumType {
  private static allValues: EnumNumberFormat[] = []; // make sure this is top-most

  public static nnnn_dot_ff = new EnumNumberFormat(
    0,
    "nnnn_dot_ff",
    "enum_number_format_nnnn_dot_ff",
    "",
    "."
  );

  public static n_space_nnn_dot_ff = new EnumNumberFormat(
    1,
    "n_space_nnn_dot_ff",
    "enum_number_format_n_space_nnn_dot_ff",
    " ",
    ""
  );

  public static n_comma_nnn_dot_ff = new EnumNumberFormat(
    2,
    "list",
    "enum_number_format_n_comma_nnn_dot_ff",
    ",",
    "."
  );

  public key: number;
  public value: string;
  public translationKey?: string;
  public thousandsSeparator: string;
  public decimalSeparator: string;

  private constructor(
    key: number,
    value: string,
    translationKey: string,
    thousandsSeparator: string,
    decimalSeparator: string
  ) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    this.thousandsSeparator = thousandsSeparator;
    this.decimalSeparator = decimalSeparator;

    EnumNumberFormat.allValues.push(this);
  }

  public equals(other: Maybe<EnumNumberFormat>): boolean {
    return this.key === other?.key;
  }

  public isNnnnDotFf() {
    return this.equals(EnumNumberFormat.nnnn_dot_ff);
  }
  public isNSpaceNnnDotFf() {
    return this.equals(EnumNumberFormat.n_space_nnn_dot_ff);
  }
  public isNCommaNnnDotFf() {
    return this.equals(EnumNumberFormat.n_comma_nnn_dot_ff);
  }

  public static getValues(): EnumNumberFormat[] {
    return EnumNumberFormat.allValues;
  }

  public static getByKey(key: number): EnumNumberFormat {
    const found = EnumNumberFormat.allValues.find((e) => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumNumberFormat - Key not found: ${key}`);
    }

    return found;
  }
}
